<div class="oi-main-dshd">
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <div class="oi-comen-heading">
          <div class="row">
            <div class="col-md-6">
              <h2>Search Q&A</h2>
            </div>
            <div class="col-md-6">
              
        
            </div>
          </div>

        </div>
        </div>
      </div>

<div class="row">
    <div class="col-md-9">
    <div class="oi-qns-ans-search-mn d-flex justify-content-start">
        <div class="oi-qns-ans-search-top">
            <p-autoComplete [(ngModel)]="query" [suggestions]="filteredQuestions" 
            (completeMethod)="search($event)"   (onSelect)="onSelect($event)"
            (keyup.enter)="performSearch()"  field="question" placeholder="Type your question here..." 
            >
            <ng-template let-question pTemplate="item">
                <div [innerHTML]="question.question | highlight:query"></div>
              </ng-template>
        </p-autoComplete>
            <!-- <input type="text" id="search" name="search" class="form-control"  [(ngModel)]="query" (keyup.enter)="search()" placeholder="Type your question here..."> -->
        </div>
        <div class="oi-qns-ans-btn-top"><button type="button" class="btn btn-primary" (click)="performSearch()"><img src="../../assets/img/search1.svg"></button></div>
    </div>
    </div>
    <div class="col-md-3">
    <div class="oi-qns-ans-drop">
        
            <p-dropdown [options]="availableCollections" [(ngModel)]="selectedCollection" optionLabel="collectionName" optionValue="collectionName" placeholder="Select a Collection" (onChange)="changeCollection($event)"></p-dropdown>
          
    </div>
    </div>
</div>

<div class="row">
    <div class="col-md-9">

        <ng-container *ngIf="loader else showcontent">
            <div class="imgloader" *ngIf="loader">
              <img src="../../assets/img/loader.gif">
            </div>
          </ng-container >
          <div class="oi-no-data-found" *ngIf="searchPerformed && saved_answers.length === 0">
            <img src="../../assets/img/found.png"><br>
            No data found <button type="button" class="btn btn-primary" (click)="navigateTogetanswer(query)">click here to get answer</button>
          </div> 
          <ng-template #showcontent>
        <div class="row">
            <div class="col-md-12">
                <div class="oi-qns-ans-bx" *ngFor="let savedanswer of saved_answers,let i=index">
                    <div class="oi-qns-ans-multi-btn">
                        <div class="button-container">
                            <button class="btn btn-primary"  pTooltip="download" >
                               <img src="../assets/img/download2.svg" (click)="downloadContent(savedanswer.answer)">
                            </button>
                            <button class="btn btn-primary" pTooltip="copy">
                                <img src="../assets/img/copy2.svg" (click)="copyContent(savedanswer.answer)">
                                <span *ngIf="isCopied" class="copied-message">Copied to clipboard!</span>
                            </button>
                           
                        </div>
                        
                    </div>
                    
                    <div class="oi-qns-ans-text-bx">
                        
                        <div class="oi-certified-icon" *ngIf="savedanswer.answer_approved==1">
                            <img src="../../assets/img/badge.png">
                          </div>
                        <div class="oi-qns-ans-txtmn" >
                            <div class="oi-qns-mn" [innerHTML]="sanitizeMessage(savedanswer.question)"></div>
                            <div class="oi-ans-mn" [innerHTML]="sanitizeMessage(savedanswer.answer)"></div>
                            
                        </div>
                        
                        <div class="oi-qns-ans-thumb-mn">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="oi-tag-container">
                                        <div *ngFor="let doc of getFilteredDocuments(savedanswer.documentReferred.documents)" class="tag" (click)="navigateToDoc(doc)">{{ doc?.document_name }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="oi-qnsans-like-btn">
                                        <div class="like-btn">
                                            <button type="button" class="btn btn-primary like" (click)="thumbsup(savedanswer.id)">
                                                <img src="../../assets/img/{{thumbsupClicked[savedanswer.id]?'thumb-up-active' : 'thumb-up'}}.svg">
                                            </button>
                                            <span>{{ savedanswer.like  || 0 }}</span>
                                        </div>
                                        <div class="like-btn">
                                            <button type="button" class="btn btn-primary dislike" (click)="thumbsdown(savedanswer.id)">
                                                <img src="../../assets/img/{{thumbsdownClicked[savedanswer.id]?'thumb-down-active' : 'thumb-down'}}.svg">
                                            </button>
                                            <span>{{ savedanswer.dislike || 0 }}</span>
                                        </div>
                                       
                                    </div>
                                    
                                </div>

                                <div class="col-md-6">
                                    <div class="oi-qnsans-ask-again-all">                    
                                            <button class="btn btn-primary"  (click)="knowledgegap(savedanswer.id)" [pTooltip]="savedanswer.knowledge_gap ? 'Knowledge Gap':''"  tooltipPosition="bottom" tooltipStyleClass="custom-tooltip">
                                              <img [src]="savedanswer.knowledge_gap ? '../assets/img/knowledge-gap-red.svg' : '../assets/img/knowledge-gap.svg'" >
                                            </button>                                          
                                        <button type="button" class="btn" pTooltip="Remap"  (click)="OpentomapAnswer(savedanswer)"><img src="../assets/img/remap.svg"></button>
                                        <button type="button" class="btn" pTooltip="Ask Again"  (click)="navigateTogetanswer(savedanswer.question)"><img src="../assets/img/again.svg"></button>
                                        <button type="button" class="btn" pTooltip="View"  ><img src="../assets/img/eye.svg" width="12px"(click)="toggleFullScreen(savedanswer)"></button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </ng-template>

    </div>
    <div class="col-md-3">
        <div class="oi-lates-new">
            <h4>Latest Question</h4>
            <ul>
                <li *ngFor="let data of topratedQuestion ">
                    <a class="txt1" (click)="serchans(data)" [innerHTML]="sanitizeMessage(data.question)"></a>
                </li>
            </ul>
        </div>
    </div>
</div>





</div>
</div>
<p-dialog [(visible)]="showmodal" [header]="dialogheader" [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onDialogHideaddcollection()">
    <div class="oi-ad-collect-mdl khdoc">
        <ng-container *ngIf="modalloader else showdata">
            <div class="imgloader">
                <img src="../../assets/img/loader.gif">
            </div>
        </ng-container>
        <ng-template #showdata>
            <div class="modal-content documnttext">
            <div class="oi-map-modal">
                <div class="oi-qns-mn" [innerHTML]="sanitizeMessage(mappedQuestion)"></div>
                <div class="oi-ans-mn" [innerHTML]="sanitizeMessage(mappedAnswer)"></div>
                <div class="oi-qns-mdl-sear-mn">
                <h1>Correct Answer</h1>
                <div class="oi-map-ans-search">
                    <div class="oi-qns-ans-search-mn d-flex justify-content-start">
                        <div class="oi-qns-ans-search-top">
                            <p-autoComplete [(ngModel)]="searchkey" [suggestions]="filteredQuestions" 
                            (completeMethod)="mapsearch($event)"   (onSelect)="onSelectmap($event)"
                            (keyup.enter)="performmapSearch()"  field="question" placeholder="Type your question here..." 
              >
                            <ng-template let-question pTemplate="item">
                                <div [innerHTML]="question.question | highlight:searchkey"></div>
                              </ng-template>
                        </p-autoComplete>
                        </div>
                        <div class="oi-qns-ans-btn-top"><button type="button" class="btn btn-primary" (click)="performmapSearch()"><img src="../../assets/img/search1.svg"></button></div>
                    </div>
                </div> 
                <ng-container *ngIf="maploader else showAnswertempate">
                    <div class="imgloader" *ngIf="loader">
                      <img src="../../assets/img/loader.gif">
                    </div>
                  </ng-container >
                <ng-template #showAnswertempate>
                <div class="oi-qns-ans-txtmn" *ngIf="answer" >
                    <div class="oi-qns-mn-map1" [innerHTML]="sanitizeMessage(answer)"></div>
                </div>
            </ng-template>
                <div class="oi-map-bottom-btn">
                    <button type="button" class="btn btn-closed" (click)="Onclose()">Close</button>
                    <button type="button" class="btn btn-map" (click)="mapAnswer()">Map</button>
                </div>

                </div>

            </div>
            </div>
        </ng-template>
    </div>

</p-dialog>
<p-toast></p-toast>